export interface MaCompany {
  name: string;
  logo: string;
}

export interface MaYear {
  yr: string;
  companies: MaCompany[];
}

export const MA_HISTORY: MaYear[] = [
  {
    yr: '2018',
    companies: [
      { name: 'Echo Bousai', logo: 'assets/logos/2018_echo-bousai.png' },
    ],
  },
  {
    yr: '2021',
    companies: [
      { name: 'TODAKA',  logo: 'assets/logos/2021_todaka.png'  },
      { name: 'DELTAX',  logo: 'assets/logos/2021_deltax.png'  },
      { name: 'SHIZUKI', logo: 'assets/logos/2021_shizuki.png' },
      { name: 'EJEC',    logo: 'assets/logos/2021_ejec.png'    },
    ],
  },
  {
    yr: '2022',
    companies: [
      { name: 'Denken Engineering', logo: 'assets/logos/2022_denken.png' },
    ],
  },
  {
    yr: '2023',
    companies: [
      { name: 'SEIWA',           logo: 'assets/logos/2023_seiwa.png'   },
      { name: 'SKE',             logo: 'assets/logos/2023_ske.png'     },
      { name: 'HINATA Electric', logo: 'assets/logos/2023_hinata.png'  },
      { name: 'T-Staff',         logo: 'assets/logos/2023_tstaff.png'  },
      { name: 'YAMADEN',         logo: 'assets/logos/2023_yamaden.png' },
      { name: 'TAIHEI',          logo: 'assets/logos/2023_taihei.png'  },
    ],
  },
  {
    yr: '2024',
    companies: [
      { name: 'KOEI', logo: 'assets/logos/2024_koei.png' },
    ],
  },
  {
    yr: '2025',
    companies: [
      { name: 'KANAMEX', logo: 'assets/logos/2025_kanamex.jpg' },
      { name: 'NILES',   logo: 'assets/logos/2025_niles.png'   },
      { name: 'FD',      logo: 'assets/logos/2025_fd.png'      },
    ],
  },
];
